import React from "react";
import type { PaginationProps } from "antd";
import { Pagination } from "antd";
import styled from "styled-components";
interface IProps {
  total?: number;
  page?: number;
  changePage: (current: number, size: number) => void;
}
export const ComponentPagination = ({ total, page, changePage }: IProps) => {
  const onShowSizeChange: PaginationProps["onShowSizeChange"] = (current, pageSize) => {
    changePage(current, pageSize);
  };
  return (
    <StyledPagination>
      <Pagination
        showSizeChanger
        onShowSizeChange={onShowSizeChange}
        onChange={onShowSizeChange}
        current={page}
        total={total}
      />
    </StyledPagination>
  );
};

const StyledPagination = styled.section`
  padding: 25px;
  display: flex;
  justify-content: center;
`;
